'use strict';
angular.module('impactx.basketAmount', [])
    .directive('appBasketAmount', ['$locale', function (){
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelController) {
                var regExp = /[^0-9.,]+/;
                ngModelController.$parsers.push(function (data) {
                    var validInput = data.toString().replace(regExp, "");
                    if (data != validInput)
                    {
                        ngModelController.$setViewValue(validInput);
                        ngModelController.$rollbackViewValue();
                    }
                    return validInput;
                });
            }
        }
    }]);